import { Source } from '../../services/ApiService';

import { ContentType } from './ContentType';
import { CorrectionType } from './CorrectionType';

export class Transaction {
  public static TYPE_INVOICE = 'invoice';
  public static TYPE_RECEIPT = 'receipt';
  public static TYPE_CURRENCY_CONVERSION = 'currency-conversion';
  public static TYPE_ROUNDING = 'rounding';
  public static TYPE_BALANCE_TRANSFER = 'balance-transfer';
  public static TYPE_PARCEL = 'parcel';
  public static TYPE_HIRE_PURCHASE_AGREEMENT = 'hire-purchase-agreement';
  public static TYPE_PREPAYMENT_REFUNDED = 'prepayment-refunded';
  public static TYPE_CORRECTION_TRANSACTION = 'correction-transaction';

  public date: Date;
  public invoiceDueDate: Date;
  public invoiceNumber: string;
  public invoiceReferenceNumber: string;
  public invoiceReferenceNumberAlias: string;
  public invoiceSource: Source;
  public invoiceContentType: ContentType;
  public receiptBindingId: number;
  public receiptDescription: string;
  public amount: number;
  public balance: number;
  public type: string;
  public receiptHirePurchaseAgreementNumber: string;
  public externalLabelKey: CorrectionType;
  public transactionComment: string;
  public invoiceServiceDetailsAccess: boolean;
}
